module.exports = "<div class=\"d3-neural-network\" #d3NuralTreeRef></div>\r\n"